module.exports = __webpack_public_path__ + "static/media/savespace.ced1f13d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/icons/savespace.svg
// module id = 367
// module chunks = 0